import { useQuery, QueryObserverOptions } from 'react-query';
import { uniq, isEmpty } from 'lodash';
import axiosClient from '@lib/utils/axiosClient';
import { ParamsIds, ResourceKeys } from '../types';

async function fetchEntityByIds<EntityName extends string, Entity>(entity: EntityName, params: ParamsIds) {
  const response = await axiosClient.get<{
    page: number;
    size: number;
    response: Entity[];
  }>(`/${entity}/crudList`, { params: { _id: params.ids.join(',') } });
  return response.data.response;
}

export function useEntityByIds<Entity>(
  keys: ResourceKeys['byIds'],
  params: ParamsIds,
  options?: QueryObserverOptions<Entity[]>,
) {
  const entityKeys = keys(params);
  const [entityName] = entityKeys;
  const ids = uniq(params.ids);
  const enabled = !isEmpty(ids) && (!options || options.enabled);
  return useQuery<Entity[]>(entityKeys, () => fetchEntityByIds(entityName, { ids }), { ...options, enabled });
}
